import cn from 'classnames';
import type { FC } from 'react';
import { enableScroll } from '@shared/helpers';
import { useAppDispatch, useAppSelector } from '@shared/hooks';
import { ButtonTransparent, ModalSmall } from 'library/components/common';
import { closeModalDichotomous, selectDichotomousProps } from 'library/redux/modal';
import * as st from './ModalDichotomous.module.scss';

const ModalDichotomous: FC = () => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(selectDichotomousProps);

  const handleConfirm = () => {
    enableScroll();
    if (!Boolean(data.closeToConfirm) && data.closeToConfirm !== undefined) {
      data.confirm && data.confirm();
    } else {
      dispatch(closeModalDichotomous());
      data.confirm && data.confirm();
    }
    // document.body.style.overflow = 'unset';
  };

  const handleReject = () => {
    enableScroll();
    dispatch(closeModalDichotomous());
    data.decline && data.decline();
    // document.body.style.overflow = 'unset';
  };

  const onRequestClose = () => {
    enableScroll();
    if (Boolean(data.onRequestClose) && data.onRequestClose !== undefined) {
      dispatch(closeModalDichotomous());
    }
  };

  return (
    <ModalSmall
      isOpen
      title={data.title}
      overlayClassName={st.overlay}
      onRequestClose={onRequestClose}
      needClose={true}
    >
      <div
        className={cn(
          st.wrapper,
          !Boolean(data.closeToConfirm) && data.closeToConfirm !== undefined && st.height
        )}
      >
        <div className={st.wrapper__text}>{data.text}</div>
        {data.link && (
          <a
            href={data.link.url}
            rel="noopener noreferrer"
            target="_blank"
            className={st.wrapper__text_link}
          >
            {data.link.text}
          </a>
        )}
      </div>
      <div className={st.buttons}>
        <div className={st.buttons__button}>
          <ButtonTransparent handler={handleConfirm} text={data.confirmText} theme="blue" />
        </div>
        <div className={st.buttons__button}>
          <ButtonTransparent handler={handleReject} text={data.declineText} theme="grey" />
        </div>
      </div>
    </ModalSmall>
  );
};

export default ModalDichotomous;
